import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { getLegalDocsServer, getLegalDocsVersion } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'
import { getRegionPrivacyPolicyTypeServer } from '@srca-b2b/kp5-ui-common/utils/generalAPIs'
import { withOpenAccessPage } from '@srca-b2b/kp5-ui-common/utils/auth'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

const title = 'Samsung Knox Privacy Policy'

const LegalAgreement = ({ legalDocsResponse, legalDocsVersions, legalType }) => {
  return (
    <Layout id={legalType} title={`${title} | Knox Partner Program`}>
      <UspPageTitle title="Legal" />
      <Container>
        <Row>
          <Col sm={12}>
            <LegalDocs
              title={title}
              agreements={legalDocsResponse.data}
              legalVersions={legalDocsVersions}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export const getServerSideProps = withOpenAccessPage(async ({ context, loggedInUser }) => {
  // Set up URL redirect for USP
  const urlMap = {
    // If you need to add an element to the list, it should be lexicographically placed.
    AE: '/en/scb-pp-ae',
    AT: '/en/scb-pp-at',
    AU: '/en/scb-pp-au',
    BE: '/en/scb-pp-benelux',
    BR: '/en/scb-pp-br',
    CA: '/en/scb-pp-ca',
    CH: '/en/scb-pp-ch',
    CZ: '/en/scb-pp-cz',
    DE: '/en/scb-pp-de',
    DK: '/en/scb-pp-nordic',
    ES: '/en/scb-pp-es',
    FI: '/en/scb-pp-nordic',
    FR: '/en/scb-pp-fr',
    GB: '/en/scb-pp-gb',
    HK: '/en/scb-pp-hk',
    ID: '/en/scb-pp-id',
    IN: '/en/scb-pp-in',
    IS: '/en/scb-pp-is',
    IT: '/en/scb-pp-it',
    KR: '/en/scb-pp-kr',
    LU: '/en/scb-pp-benelux',
    MX: '/en/scb-pp-mx',
    MY: '/en/scb-pp-my',
    NL: '/en/scb-pp-benelux',
    NO: '/en/scb-pp-nordic',
    PH: '/en/scb-pp-ph',
    PL: '/en/scb-pp-pl',
    RO: '/en/scb-pp-ro',
    SA: '/en/scb-pp-sa',
    SE: '/en/scb-pp-nordic',
    SG: '/en/scb-pp-sg',
    SK: '/en/scb-pp-sk',
    TR: '/en/scb-pp-tr',
    TW: '/en/scb-pp-tw',
    US: '/en/scb-pp-us',
    VN: '/en/scb-pp-vn'
  }
  let redirectUrl = null
  Object.keys(urlMap).forEach((key) => {
    if (redirectUrl) {
      return
    }
    if (key in context.query || key.toLowerCase() in context.query) {
      redirectUrl = urlMap[key]
      return
    }
  })
  if (redirectUrl) {
    return {
      redirect: {
        destination: redirectUrl,
        permanent: false
      }
    }
  }

  const regionPpResponse = await getRegionPrivacyPolicyTypeServer()
  if (!('noRedirect' in context.query) && regionPpResponse.statusCode === 200) {
    let redirect
    const policyLegalType = regionPpResponse.data?.knoxPrivacyPolicy?.legalType
    switch (policyLegalType) {
      case 'privacy_policy_ko':
        redirect = `/en/privacy-policy-ko`
        break
      case 'privacy_policy_br':
        redirect = `/en/privacy-policy-br`
        break
      case 'privacy_policy_tk':
        redirect = `/en/privacy-policy-tk`
        break
      case 'privacy_policy_usa':
        redirect = `/en/privacy-policy-us`
        break
      case 'privacy_policy_eu':
        redirect = `/en/privacy-policy-eu`
        break
      case 'privacy_policy_cn':
        redirect = `/en/privacy-policy-cn`
        break
      case 'privacy_policy_latam':
        redirect = `/en/privacy-policy-latam`
        break
      case 'registration_privacy_policy':
      default:
        redirect = `${publicRuntimeConfig.kp4BaseUrl}/web-privacy-policy`
        break
    }
    if (redirect) {
      return {
        redirect: {
          destination: redirect,
          permanent: false
        }
      }
    }
  }

  const contentLegalType =
    'kaa' in context.query ? 'registration_privacy_policy_kaa' : 'registration_privacy_policy'
  const legalDocsVersionsResponse = await getLegalDocsVersion(contentLegalType)
  const legalDocsResponse = await getLegalDocsServer([contentLegalType])
  if (legalDocsResponse.statusCode !== 200) {
    return {
      redirect: {
        destination: '/en/404',
        permanent: false
      }
    }
  }

  let legalDocsVersions = []
  if (legalDocsVersionsResponse.statusCode === 200 && legalDocsVersionsResponse.data[0]) {
    legalDocsVersions = legalDocsVersionsResponse.data[0].versions
  }

  const props = { legalDocsResponse, legalDocsVersions, legalType: contentLegalType }
  if (loggedInUser) {
    props.loggedInUser = loggedInUser
  }
  return {
    props
  }
})

export default LegalAgreement
